export function paymentType(state) {
  return state.paymentType;
}
